import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=62c6c9c6&scoped=true"
import script from "./TableWrapper.vue?vue&type=script&lang=ts"
export * from "./TableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TableWrapper.vue?vue&type=style&index=0&id=62c6c9c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6c9c6",
  null
  
)

export default component.exports